import { createApp } from 'vue'

import App from './App.vue'
import router from "./router";
import BootstrapVue3 from 'bootstrap-vue-3';
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';
import Maska from 'maska'
import {i18n} from "./i18n.js"
import { initFirebaseBackend } from './authUtils'
import { configureFakeBackend } from './helpers/fake-backend';
import VueQRCodeComponent from 'vue-qrcode-component'
import VueTypewriterEffect from "vue-typewriter-effect"

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';

import store from "./state/store";

import "../src/design/app.scss";

import 'devextreme/dist/css/dx.light.css';
import { registerLicense } from '@syncfusion/ej2-base';

registerLicense('MzQ2MjgwNUAzMjMxMmUzMDJlMzBYR1AyYzlybW9DekR5eEpjLzdXdEZ3USt2azlTdXNMT3F6Z1ladTVrcm5rPQ==;MzQ2MjgwNkAzMjMxMmUzMDJlMzBSM1p4eHhaQjlOa1pjZEhBaTRGSSthZ2czcEZ4eDhvQlBsd00yZkg3ZXRRPQ==;Mgo+DSMBaFt+QHJqVEZrXVNbdV5dVGpAd0N3RGlcdlR1fUUmHVdTRHRbQlRjT35bd0dnWXxfcnQ=;Mgo+DSMBPh8sVXJ1S0R+XVFPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9nSXdTcEVrWH1acHdXQWY=;ORg4AjUWIQA/Gnt2VFhiQlBEfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5adkNjUX5cdHRWQmNf;NRAiBiAaIQQuGjN/V0d+Xk9FdlRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3pTf0VlWXdfcnBVRWVUWA==;MzQ2MjgxMUAzMjMxMmUzMDJlMzBJdkN6eU55cmN6MlZhUCtGbWhuZ3h1b1BhQmo2L3VkUGFoK29ydXkwWnE4PQ==;MzQ2MjgxMkAzMjMxMmUzMDJlMzBjMFU5dkxScUNaRFQ4b3huZEgrQk1jK3F3cm1uVEZTNE9KUkRUOUpObEhvPQ==;Mgo+DSMBMAY9C3t2VFhiQlBEfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5adkNjUX5cdHRRRWdY;MzQ2MjgxNEAzMjMxMmUzMDJlMzBNT2d6SkRySHpQMm5wUlBzeDkwWFltdkVKOUQ1OGloWjA3VHJVcVFMTXZ3PQ==;MzQ2MjgxNUAzMjMxMmUzMDJlMzBUUEdja2E2dXFQU3NuREZ3VDI2dldvK2Faek9TWlo5K1pTeGVMMkcrTXhVPQ==;MzQ2MjgxNkAzMjMxMmUzMDJlMzBJdkN6eU55cmN6MlZhUCtGbWhuZ3h1b1BhQmo2L3VkUGFoK29ydXkwWnE4PQ==');

createApp(App)
  .use(store)
  .use(router)
  .use(require('vue-chartist'))
  .use(BootstrapVue3)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(i18n)
  .use(registerScrollSpy)
  .use(Maska)

  .component('qr-code', VueQRCodeComponent)
  .component("vue-typewriter-effect", VueTypewriterEffect)
  .mount('#app')


